enum TicketTypes {
    EGE = 'EGE',
    THEMATIC = 'THEMATIC'
}

export default TicketTypes;